import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "row g-6 g-xl-9 mb-6 mb-xl-9" }
const _hoisted_2 = { class: "col-md-6 col-lg-4 col-xl-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-plus text-primary mb-5 fa-4x" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-white fs-5 fw-bold mb-2" }, "Create Production", -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EntityCard = _resolveComponent("EntityCard")!
  const _component_CreateProductionModal = _resolveComponent("CreateProductionModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productions, (production) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "col-md-6 col-lg-4 col-xl-3",
        key: production.productionId
      }, [
        _createVNode(_component_EntityCard, { entity: production }, null, 8, ["entity"])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "card h-100 flex-center bg-light-primary border-primary border border-dashed p-8 cursor-pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.invokeCreateProduction(_ctx.organizationId)))
      }, _hoisted_5)
    ]),
    _createVNode(_component_CreateProductionModal, { ref: "createProductionModal" }, null, 512)
  ]))
}